export const initialValues = {
  name: '',
  cpf: '',
  rg: '',
  cell_phone: '',
  email: '',
  company: { id: '' },
  group: { id: 1, name: 'Sistema' },
  units: [],
  permissions: [],
};
